import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-save-group',
  templateUrl: './save-group.page.html',
  styleUrls: ['./save-group.page.scss'],
})
export class SaveGroupPage implements OnInit {
  dataExtras: any = {};
  groupName:string;
 bookingPlayers:any;

  constructor(private modalCtl: ModalController, private router: Router, private navParams: NavParams,) {   
    this.bookingPlayers  = this.navParams.get("bookingPlayers");
  }

  ngOnInit() {
  }
  close() {
    this.modalCtl.dismiss();
  }

  getImage(item: any) {
    // PlayerInfo
    if (item.thumbnail) return item.thumbnail;
    else if (item.photoUrl) return item.photoUrl;
    else if (item.profile) return item.profile;
    else if (item.image) return item.image;
    else
      return 'assets/image/default-user.jpg';
  }

  addGroup(){
    this.modalCtl.dismiss({
      groupName: this.groupName
  });
  }
}
